import CardGroup from './CardGroup';

export type { CardGroupProps } from './CardGroup';
export default CardGroup;
